import React, { useEffect, useState } from "react";
import { Dialog } from "@mui/material";
import { Icon } from "@iconify/react";
import { FileDropzone } from "../components/shared/FileDropzone";
import {
  ButtonPrimary,
  ButtonPrimary1,
  HStack,
  VStack,
} from "../components/utils";
import { Instructions } from "../components/shared/Instructions";

interface UploadFafLetterDialogProps {
  open: boolean;
  onClose: () => void;
  onUpload: (file: File) => void;
  uploading: boolean;
}

export default function UploadFafLetterDialog({
  open,
  onClose,
  onUpload,
  uploading,
}: UploadFafLetterDialogProps) {
  const [selectedFile, setSelectedFile] = useState<File | undefined>();

  useEffect(() => {
    if (!open) {
      setSelectedFile(undefined);
    }
  }, [open]);

  function handleClose() {
    if (uploading) return;
    setSelectedFile(undefined);
    onClose();
  }

  function handleUpload() {
    if (selectedFile) {
      onUpload(selectedFile);
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <div className="bg-white rounded-lg">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-5 border-b">
          <h6 className="text-lg font-medium text-gray-dark">
            Upload Settlement Letter
          </h6>
          <span
            onClick={handleClose}
            className="cursor-pointer text-gray-500 hover:text-gray-700"
          >
            <Icon icon="material-symbols:close" width={20} />
          </span>
        </div>

        {/* Body */}
        <VStack className="gap-4 px-6 py-5">
          {/* Note */}

          {/* Dropzone */}
          <FileDropzone
            onFileSelect={setSelectedFile}
            onClear={() => setSelectedFile(undefined)}
            selectedFile={selectedFile}
            acceptedFileExtensions={[".pdf"]}
            instructionText="PDF files only (.pdf)."
            disabled={uploading}
          />
          <Instructions
            data={[
              "Please ensure the settlement letter is in PDF format and does not exceed 5MB in size.",
              "We assume this is a completed settlement letter with all necessary signatures and details. Please review the document before uploading.",
            ]}
          />
        </VStack>

        {/* Footer */}
        <HStack className="justify-between  gap-3 px-6 py-4 border-t">
          <ButtonPrimary1 onClick={handleClose} disabled={uploading}>
            Cancel
          </ButtonPrimary1>
          <ButtonPrimary
            onClick={handleUpload}
            disabled={!selectedFile || uploading}
            loading={uploading}
          >
            Upload
          </ButtonPrimary>
        </HStack>
      </div>
    </Dialog>
  );
}
